import React from 'react';
import GalleryArrow from './components/GalleryArrow/GalleryArrow';
import { getNextIcon, getPrevIcon } from './helpers/arrowIconIdentifier';

const getGallerySwiperParams = ({ isMobile, isRtl, className, title = {} }) => {
  const arrowProps = {
    className,
    isMobile
  };

  const { prevParams = '', nextParams = '' } = title;

  return ({
    spaceBetween: 10,
    navigation: {
      nextEl: getNextIcon(isMobile, isRtl),
      prevEl: getPrevIcon(isMobile, isRtl),
      disabledClass: 'disabled-arrow'
    },
    renderCustomPrevButton: () => (
      <GalleryArrow
        position={isRtl ? 'right' : 'left'}
        title={prevParams}
        {...arrowProps}
      />
    ),
    renderCustomNextButton: () => (
      <GalleryArrow
        position={isRtl ? 'left' : 'right'}
        title={nextParams}
        {...arrowProps}
      />
    )
  });
};

export default getGallerySwiperParams;
